<template>
  <transition name="fade-enter">
    <div
      v-if="isVisible"
      ref="modal"
      :class="{'s-modal--mobile': isMobile}"
      class="s-modal"
      @click.self="onOverlayClick">
      <div class="s-modal__wrapper">
        <div
          class="s-modal__close"
          @click="close">
          <icon
            name="x"
            width="14"
            height="14"
            class="s-icon"/>
        </div>
        <header
          v-if="$slots.header || title"
          class="s-modal__header">
          <slot name="header"/>
          <p
            v-if="title"
            class="s-modal__title"> {{ title }} </p>
        </header>
        <div class="s-modal__content">
          <slot/>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import breakpoints from '@/components/UI/helpers/breakpoints'

export default {
  mixins: [breakpoints],
  props: {
    name: {
      required: true,
      type: String
    },
    title: {
      required: false,
      type: String,
      default: ''
    },
    overlayClick: {
      required: false,
      type: [Function, Boolean],
      default: false
    }
  },
  data () {
    return {
      isVisible: false
    }
  },
  beforeMount () {
    this.$bus.$on('modal-toggle', (name, state, params) => {
      if (name === this.name) {
        state = typeof state === 'undefined' ? !this.isVisible : state
        this.toggle(state)
      }
    })
    this.$bus.$on('modal-show', (name, state, params) => name === this.name ? this.toggle(true) : false)
    this.$bus.$on('modal-hide', (name, state, params) => name === this.name ? this.toggle(false) : false)
  },
  destroyed () {
    this.$bus.$off('modal-toggle')
    this.$bus.$off('modal-show')
    this.$bus.$off('modal-hide')
  },
  methods: {
    toggle (state) {
      this.isVisible = state
      document.documentElement.classList.toggle('s-modal--overflow', state)
    },
    close () {
      this.$emit('close')
      this.toggle(false)
    },
    onOverlayClick () {
      return this.overlayClick ? this.overlayClick() : this.close()
    }
  }
}
</script>
<style src="./styles/Modal.scss" lang="scss"/>



// WEBPACK FOOTER //
// src/components/UI/Modal/Modal.vue